var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41174 10.1768H8.76494C9.54466 10.1768 10.1768 9.54466 10.1768 8.76494V2.41174C10.1768 1.63201 9.54466 0.999918 8.76494 0.999918H2.41174C1.63201 0.999918 0.999918 1.63201 0.999918 2.41174V8.76494C0.999918 9.54466 1.63201 10.1768 2.41174 10.1768Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 5.2362V11.5894C13.0005 11.9638 12.8517 12.3229 12.587 12.5877C12.3222 12.8525 11.9631 13.0012 11.5887 13.0012H5.23547",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.3774d023.svg";
export { ForwardRef as ReactComponent };